import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Typography } from '../../atoms/Typography'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import { PcSpWidth } from 'src/components/shared/Constant'
import badgeBanner from 'src/images/top/award/itreview-banner.png'
import badgeBannerPC from 'src/images/top/award/itreview-banner-pc.png'
import badgeBannerSP from 'src/images/top/award/itreview-banner-sp.png'

export const TopAward: React.VFC = () => {
  return (
    <Wrapper>
      <Container>
        <Award>
          <img src={badgeBanner} alt="badge-banner" width="100%" height="auto"/>
        </Award>
        <AwardPC>
          <img src={badgeBannerPC} alt="badge-banner-pc" width="100%" height="90%"/>
        </AwardPC>
        <AwardSP>
          <img src={badgeBannerSP} alt="badge-banner-pc" width="100%" height="90%"/>
        </AwardSP>
      </Container>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 990px;
  margin: 0 auto ${Styles.spacing[6]};
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    padding: 0 50px;
    margin: 0 auto ${Styles.spacing[10]};
  }
`

const Container = styled.div`
  padding: ${Styles.spacing[8]} ${Styles.spacing[10]}
    calc(${Styles.spacing[10]} + ${Styles.spacing[5]});
    text-align: center;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[8]} 6vw
      calc(${Styles.spacing[5]} + ${Styles.spacing[5]});
  }

  @media screen and (min-width: ${BreakPoint.TABLET}) {
    padding: ${Styles.spacing[8]} 6vw ${Styles.spacing[10]};
    display: flex;
  }
  @media screen and (min-width: 1090px) {
    padding: ${Styles.spacing[8]} ${Styles.spacing[10]} ${Styles.spacing[5]};
  }
`

const Award = styled.div`
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    width: 50%;
  }
  @media screen and (max-width: ${BreakPoint.TABLET}) {
    width: 70%;
    margin: 0 auto;
  }
  @media screen and (max-width: ${BreakPoint.MOBILE}) {
    width: 100%;
  }
`

const AwardPC = styled.div`
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    width: 50%;
  }
  @media screen and (max-width: ${BreakPoint.TABLET}) {
    display: none;
  }
`

const AwardSP = styled.div`
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    display: none;
  }
  @media screen and (max-width: ${BreakPoint.TABLET}) {
    width: 70%;
    margin: 0 auto;
  }
  @media screen and (max-width: ${BreakPoint.MOBILE}) {
    width: 100%;
  }
`
